// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__Wx3oF","itemTitle":"ClientEmergencyInfo_itemTitle__1Nqtz","itemText":"ClientEmergencyInfo_itemText__2g0vn"};